import { Store, Module, ActionContext } from "vuex";
import ListModule from "./list-module";
import ListState from "./list-state";
import Ajax from "../../lib/ajax";
import PageResult from "@/store/entities/page-result";
import appconst from "../../lib/appconst";

interface SessionPrintCollectionCodeState extends ListState<any> {
  types: Array<any>;
}
class SessionPrintCollectionCodeModule extends ListModule<
  SessionPrintCollectionCodeState,
  any,
  any
> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<any>(),
    loading: false,
    types: new Array<any>(),
  };
  actions = {
    async getAll(
      context: ActionContext<SessionPrintCollectionCodeState, any>,
      payload: any
    ) {
      context.state.loading = true;
      const {
        data: { result },
      } = await Ajax.get(
        "/api/services/app/SessionPrintCollectionCode/GetAll",
        {
          params: payload.data,
        }
      );
      context.state.loading = false;
      const page = result as PageResult<any>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },

    async get(
      context: ActionContext<SessionPrintCollectionCodeState, any>,
      payload: any
    ) {
      let reponse = await Ajax.get(
        "/api/services/app/SessionPrintCollectionCode/GetDetail?Id=" +
          payload.data.id
      );
      return reponse.data.result;
    },
    async create(
      context: ActionContext<SessionPrintCollectionCodeState, any>,
      payload: any
    ) {
      await Ajax.post(
        "/api/services/app/SessionPrintCollectionCode",
        payload.data
      );
    },
    async export(
      context: ActionContext<SessionPrintCollectionCodeState, any>,
      payload: any
    ) {
      window.open(
        `${
          appconst.remoteServiceBaseUrl
        }export/exportCollectionCodes${abp.utils.buildQueryString(
          Object.keys(payload.data).map((key) => {
            return {
              name: key,
              value: payload.data[key],
            };
          }),
          true
        )}`,
        "_blank"
      );
    },
  };
  mutations = {
    setCurrentPage(state: SessionPrintCollectionCodeState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: SessionPrintCollectionCodeState, pagesize: number) {
      state.pageSize = pagesize;
    },
  };
}
const sessionPrintCollectionCodeModule = new SessionPrintCollectionCodeModule();
export default sessionPrintCollectionCodeModule;
